import React from 'react';
import { Loading } from '@fasstech/middle-design-system';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SimulationOfferGroupProtectionForm from './SimulationOfferGroupProtectionForm.jsx';
import useGetSimulationOfferGroupProtectionQuery from './hooks/useGetSimulationOfferGroupProtectionQuery.js';

const SimulationOfferGroupProtection = ({ getMiddleText }) => {
  const { getSimulationOfferGroupProtection, loading } =
    useGetSimulationOfferGroupProtectionQuery();

  if (loading) {
    return <Loading />;
  }

  return (
    <SimulationOfferGroupProtectionForm
      getSimulationOfferGroupProtection={getSimulationOfferGroupProtection}
      getMiddleText={getMiddleText}
    />
  );
};

export default withMiddleFeatures(SimulationOfferGroupProtection);
